module.exports = __webpack_public_path__ + "static/media/dangerous-good.008f4a5e.jpg";